import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Avatar, Rating } from '@mui/material';

const testimonials = [
    {
        id: 1,
        name: 'Sarah M.',
        role: 'Parent of 4yo',
        content: 'The "Right Brain Intensive" track has been a game-changer for my son. His memory and focus have improved dramatically in just a few weeks!',
        rating: 5,
        avatarColor: '#FF5722' // Deep Orange
    },
    {
        id: 2,
        name: 'James P.',
        role: 'Parent of 5yo',
        content: 'We love the hybrid model. The online sessions are engaging, and the in-person socials at Mill Creek are a great way to connect with other families.',
        rating: 5,
        avatarColor: '#2196F3' // Blue
    },
    {
        id: 3,
        name: 'Emily L.',
        role: 'Parent of 3yo',
        content: 'Ms. Ashwathy is wonderful! Her passion for early education really shines through. My daughter looks forward to her "school time" every day.',
        rating: 5,
        avatarColor: '#4CAF50' // Green
    }
];

const Testimonials = () => {
    return (
        <Box sx={{ py: 12, bgcolor: '#f9f9f9' }}>
            <Container maxWidth="lg">
                <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                    What Parents Say
                </Typography>
                <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 8, maxWidth: '600px', mx: 'auto' }}>
                    Hear from families who have unlocked their child's potential with Early Education Nook.
                </Typography>
                <Grid container spacing={4}>
                    {testimonials.map((testimonial) => (
                        <Grid item xs={12} md={4} key={testimonial.id}>
                            <Card
                                elevation={2}
                                sx={{
                                    height: '100%',
                                    borderRadius: 4,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transition: 'transform 0.2s',
                                    '&:hover': { transform: 'translateY(-5px)', boxShadow: 4 }
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1, p: 4 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                        <Avatar sx={{ bgcolor: testimonial.avatarColor, mr: 2 }}>
                                            {testimonial.name.charAt(0)}
                                        </Avatar>
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                {testimonial.name}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {testimonial.role}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Rating value={testimonial.rating} readOnly sx={{ mb: 2 }} />
                                    <Typography variant="body1" color="text.secondary" sx={{ fontStyle: 'italic', lineHeight: 1.6 }}>
                                        "{testimonial.content}"
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Testimonials;
